// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Html5OutlinedSvg from "@ant-design/icons-svg/es/asn/Html5Outlined";
import AntdIcon from '../components/AntdIcon';

var Html5Outlined = function Html5Outlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: Html5OutlinedSvg
  }));
};

Html5Outlined.displayName = 'Html5Outlined';
export default React.forwardRef(Html5Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/Html5Outlined.js
// module id = 1329
// module chunks = 0